import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { BazisMapService } from '@bazis/map/services/map.service';
import { BazisMapComponent } from '@bazis/map/map.component';

@Component({
    selector: 'app-map',
    templateUrl: 'map.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [BazisMapService],
    standalone: false
})
export class MapComponent extends BazisMapComponent implements OnInit {
    @Input() showSearch = true;

    // @Input() resizeControlEnabled = false;

    @Input()
    lassoEnabled = true;

    @Output()
    lassoSelected = new EventEmitter();

    lassoIsActive = false;

    // isColllapse = false;

    constructor(public mapService: BazisMapService) {
        super(mapService);
    }

    toogleLasso() {
        this.lassoIsActive = !this.lassoIsActive;
    }
}
